import React from 'react';
import OpenLDAPFeatureCard from './OpenLDAPFeatureCard';
import { OpenLDAPFeature } from '../../../types/openldap';

interface OpenLDAPFeaturesProps {
  title: string;
  items: OpenLDAPFeature[];
}

const OpenLDAPFeatures: React.FC<OpenLDAPFeaturesProps> = ({ title, items }) => {
  return (
    <div>
      <h3 className="text-2xl font-semibold text-gray-800 text-center mb-12">
        {title}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {items.map((feature, index) => (
          <OpenLDAPFeatureCard
            key={index}
            {...feature}
          />
        ))}
      </div>
    </div>
  );
};

export default OpenLDAPFeatures;